import { Branding } from "@/types/branding";

export const BASE_API_URL =
  process.env.NEXT_PUBLIC_API_URL || "http://localhost:9292";

export async function getBranding(slug: string) {
  const response = await fetch(`${BASE_API_URL}/custom/${slug}/branding`);
  if (response.status !== 200) {
    return null;
  }
  return response.json() as Promise<Branding | null>;
}

export async function getI18n(slug: string) {
  const response = await fetch(`${BASE_API_URL}/custom/${slug}/i18n`);
  if (response.status !== 200) {
    return {};
  }
  return response.json();
}

export async function getAgreementsLastUpdatedAt(slug: string) {
  const response = await fetch(
    `${BASE_API_URL}/agreements/${slug}/last-updated-at`,
  );
  if (response.status !== 200) {
    return null;
  }
  const data = (await response.json()) as { last_updated_at?: string | null };
  return data?.last_updated_at ?? null;
}
